import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader, Button, Col, FormGroup, Input, FormFeedback, Form} from 'reactstrap';

class ModalContacts extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isModalOpen: false,
            isSendButtonEnabled: false,
            firstName: '',
            telNum: '',
            email: '',
            message: '',
            touched: {
                firstName: false,
                telNum: false,
                email: false
            }

        };

        this.toggleModal = this.toggleModal.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.fnInput = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.firstName !== prevState.firstName || this.state.telNum !== prevState.telNum || this.state.email !== prevState.email){
            const errors = this.validate(this.state.firstName, this.state.telNum, this.state.email);

            let validationCheck = Boolean( this.state.firstName !== '' && this.state.telNum !== '' && this.state.email !== '' &&
                errors.firstName === '' && errors.telNum === '' && errors.email === '');

            this.setState({
                isSendButtonEnabled : validationCheck
            })
        }
    }

    handleInputChange = (event) => {
        console.log('handleInputChange' + event.target);
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    };

    toggleModal = () => {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
        if(!this.state.isModalOpen){
            this.clearFormInputs();
        }
    };

    handleBlur = (field) => (evt) => {
        console.log('blur');
        this.setState({
                touched: { ...this.state.touched, [field]: true },
        });
    };

    validate = (firstName, telNum, email) => {
        const errors = {
            firstName: '',
            telNum: '',
            email: ''
        };

        if (this.state.touched.firstName && firstName.length < 2)
                errors.firstName = 'First Name should be > 2 characters';
            else if (this.state.touched.firstName && firstName.length > 30)
                errors.firstName = 'First Name should be <= 30 characters';

        const reg = /^[\d+()-]+$/;
        if (this.state.touched.telNum && !reg.test(telNum))
                errors.telNum = 'Tel. Number should contain only numbers';

        if (this.state.touched.email && email.split('').filter(x => x === '@').length !== 1)
            errors.email = 'Email should contain a @';

            return errors;
    };

    handleSubmit = (event) => {
        //this.props.postFeedback(values.firstName, values.lastName, values.telNum, values.email, values.agree, values.contactType, values.message);
        event.preventDefault();
        console.log('Current State is: ' + JSON.stringify(this.state));
        //alert('Current State is: ' + JSON.stringify(this.state));

        this.props.onSendFeedbackClick(this.state);

        this.clearFormInputs();
        this.toggleModal();
    };

    clearFormInputs = () => {
        console.log('clearFormInputs');
        this.setState({
            firstName: '',
            telNum: '',
            email: '',
            message: '',
            touched: {
                firstName: false,
                telNum: false,
                email: false
            }
        });
    };

    onModalClose = () => {
        console.log('onModalClose_Contacts');
        if(document.fullscreen) {
            document.getElementById('root').style.display = 'flex';
        }
    };

    onInputClick = (e) => {
        e.preventDefault();
        console.log('onInputClick');
        this.fnInput.current.focus();
    };

    render() {
        const errors = this.validate(this.state.firstName, this.state.telNum, this.state.email);

        return (
            <Modal size='lg' isOpen={this.state.isModalOpen} toggle={this.toggleModal} centered={true} onClosed={this.onModalClose} onExit={this.onModalClose}>
                <ModalHeader toggle={this.toggleModal}><span>{this.props.translation.t('MODAL_FEEDBACK_TITLE')}</span></ModalHeader>
                <ModalBody>
                    <div className="col-12 col-md-9 mx-auto">
                        <Form model="feedback" onSubmit={(values) => this.handleSubmit(values)}>
                            <FormGroup row>
                                <Col md={12}>
                                    <Input type="text" id="firstName" name="firstName"
                                           model=".firstName"
                                           placeholder={this.props.translation.t('MODAL_FEEDBACK_NAME')}
                                           value={this.state.firstName}
                                           invalid={errors.firstName !== ''}
                                           onBlur={this.handleBlur('firstName')}
                                           onClick={this.onInputClick}
                                           ref={this.fnInput}
                                           onChange={this.handleInputChange} />
                                    <FormFeedback>{errors.firstName}</FormFeedback>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col md={12}>
                                    <Input type="tel" id="telNum" name="telNum"
                                           placeholder="+38(0__)-___-__-__"
                                           value={this.state.telNum}
                                           invalid={errors.telNum !== ''}
                                           onBlur={this.handleBlur('telNum')}
                                           onChange={this.handleInputChange} />
                                    <FormFeedback>{errors.telNum}</FormFeedback>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col md={12}>
                                    <Input type="email" id="email" name="email"
                                           placeholder={this.props.translation.t('MODAL_FEEDBACK_MAIL')}
                                           value={this.state.email}
                                           invalid={errors.email !== ''}
                                           onBlur={this.handleBlur('email')}
                                           onChange={this.handleInputChange} />
                                    <FormFeedback>{errors.email}</FormFeedback>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col md={12}>
                                    <Input type="textarea" id="message" name="message"
                                           rows="5"
                                           placeholder={this.props.translation.t('MODAL_FEEDBACK_DESCRIPTION')}
                                           value={this.state.message}
                                           onChange={this.handleInputChange}>
                                    </Input>
                                </Col>
                            </FormGroup>
                            <Button type="submit" color="secondary" className='mx-auto' style={{width : '100%'}} disabled={!this.state.isSendButtonEnabled}>
                                {this.props.translation.t('MODAL_FEEDBACK_SEND_TITLE')}
                            </Button>
                        </Form>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default ModalContacts;
